/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  UpdateSampleRequestMutationRequest,
  UpdateSampleRequestMutationResponse,
  UpdateSampleRequestPathParams,
  UpdateSampleRequest400,
  UpdateSampleRequest404,
} from '../types/UpdateSampleRequest'

function getUpdateSampleRequestUrl({
  id,
}: {
  id: UpdateSampleRequestPathParams['id']
}) {
  const res = {
    method: 'PUT',
    url: `/api/v1/samples/sample-requests/${id}/` as const,
  }
  return res
}

/**
 * @description Update an existing sample request.
 * Returns:
 * 200: Sample request updated successfully
 * 400: Validation error or business logic error
 * 404: Sample request not found
 * 500: Unexpected server error
 * @summary Update a sample request
 * {@link /api/v1/samples/sample-requests/:id/}
 */
export async function updateSampleRequest(
  { id }: { id: UpdateSampleRequestPathParams['id'] },
  data: UpdateSampleRequestMutationRequest,
  config: Partial<RequestConfig<UpdateSampleRequestMutationRequest>> & {
    client?: Client
  } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const requestData = data

  const res = await request<
    UpdateSampleRequestMutationResponse,
    ResponseErrorConfig<UpdateSampleRequest400 | UpdateSampleRequest404>,
    UpdateSampleRequestMutationRequest
  >({
    method: 'PUT',
    url: getUpdateSampleRequestUrl({ id }).url.toString(),
    data: requestData,
    ...requestConfig,
  })
  return res.data
}
